export default function AboutSection() {
  const values = [
    { icon: "ri-compass-3-line", t: "信源优先", d: "宁可慢，不可假。所有内容优先使用可溯源的一手信源。" },
    { icon: "ri-eye-off-line", t: "事实与观点分离", d: "客观信息与主观评论分开标注，不把猜测当结论。" },
    { icon: "ri-history-line", t: "追踪到底", d: "事件不停更就持续跟进，每次进展都在原条目串联呈现。" },
    { icon: "ri-article-line", t: "完整呈现", d: "保留历史说法与后续反转，让读者掌握全貌而非片段。" },
  ];

  return (
    <section id="about" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-newspaper-line"></i>
              关于扒哥吃瓜前线
            </div>
            <h2 className="font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              一家把“吃瓜”当严肃事做的编辑室
            </h2>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-700 md:text-base">
              八卦人人爱看，但信息爆炸的当下，真正有价值的不是“谁又翻车了”，而是“这件事到底是不是真的、后续怎么样了”。扒哥吃瓜前线正是为回答这两个问题而生。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-600 md:text-base">
              我们专注热点事件的辟谣、反转、当事人回应与新瓜进展，用分层呈现与持续追踪的方式，帮你在围观中保持清醒，不被任何一方带节奏。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {["截图比对", "多源交叉", "信息时间线", "持续追踪"].map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 rounded-md bg-background-200/70 px-3 py-1.5 text-xs font-medium text-foreground-700"
                >
                  <i className="ri-verified-badge-line text-secondary-600"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {values.map((v) => (
              <div key={v.t} className="rounded-xl border border-background-200 bg-background-100 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/10 text-primary-600">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{v.t}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.d}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid gap-4 rounded-xl border border-background-200 bg-background-100 p-6 md:grid-cols-3 md:items-center">
          <div>
            <div className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">联系我们</div>
            <p className="mt-1 text-sm text-foreground-600">提供线索、指正报道或商务合作，欢迎留言。</p>
          </div>
          <div className="flex flex-col gap-2 md:col-span-2">
            <a
              href="mailto:hello@bage-chigua.cn"
              className="inline-flex items-center gap-2 text-sm font-medium text-foreground-800 hover:text-primary-600"
            >
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-background-200 text-foreground-700">
                <i className="ri-mail-line"></i>
              </span>
              hello@bage-chigua.cn
            </a>
            <p className="text-xs leading-relaxed text-foreground-500">
              提供线索时请尽量附上可核验的信息源链接，编辑将先核实再跟进。我们不对任何未经证实的信息进行主观定性。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}